import {CreateBranchDialogFindRepoBranchesServerQuery as queryId} from '@github-ui/server-persisted-queries'
import type {CreateBranchDialogFindRepoBranchesServerQueryQuery as QueryData} from '@github-ui/server-persisted-queries/types/CreateBranchDialogFindRepoBranchesServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function createBranchDialogBranchesQueryKey(owner: string, repo: string) {
  return ['issue-viewer', 'create-branch-dialog-branches', {owner, repo}] as const
}

export async function fetchCreateBranchDialogBranches(
  owner: string,
  repo: string,
  signal?: AbortSignal,
): Promise<QueryData> {
  const url = `/${owner}/${repo}/create_branch_dialog_branches.json?queryId=${queryId}`
  const response = await reactFetchJSON(url, {signal})

  if (!response.ok) throw new Error(`Create branch dialog branches fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: QueryData; errors?: unknown[]}
  if (!json.data) throw new Error('Create branch dialog branches query returned no data')

  return json.data
}
